import { LIGHTNING_PAYMENT_STATE } from '../constants/cache-constants';

const DEFAULT_RECEIVER_NAME = 'Sin receptor';
const BCI_TOOLTIP_TEXT = 'Convenio pronto pago - BCI';
const FAST_PAYMENT_TITLE = 'Factura autorizada para pago rápido';

export const getLightningPaymentTooltip = (invoice) => {
  const { lightningPaymentState, receiver } = invoice;

  if (lightningPaymentState === LIGHTNING_PAYMENT_STATE.STANDARD) {
    const receiverName = receiver?.name || DEFAULT_RECEIVER_NAME;
    const subtitle = `Portal de proveedores: ${receiverName}`;

    return {
      text: `${subtitle}. ${FAST_PAYMENT_TITLE}`,
      subtitle,
      title: FAST_PAYMENT_TITLE,
    };
  }

  if (lightningPaymentState === LIGHTNING_PAYMENT_STATE.BCI) {
    return {
      text: BCI_TOOLTIP_TEXT,
      subtitle: BCI_TOOLTIP_TEXT,
      title: null,
    };
  }

  return null;
};

export const getLightningPaymentTooltipText = (invoice) => (
  getLightningPaymentTooltip(invoice)?.text ?? ''
);
